<template>
  <div>
    <van-nav-bar title="关于" :fixed="true" :left-arrow="!hideBackBtn" @click-left="goback"  />
    <div class="container">
      <h4>水质微站描述</h4>
      <p class="contennt">
        水质微站可同时快速检测多种水质参数，可达分钟级检测周期，直接投入水中安装，安装过程简单方便，可以实现单人安装，也可以灵活移动安装位置，原位检测，无需样品采集，前处理及试剂和耗材，体积小，重量轻，功耗低，数据实时无线传输至云端，实时可视，实时报警，可全天候连续运行，运维成本大大降低。
      </p>
      <p class="contennt">
        水质微站集成的多参数探头，是基于光学和电化学检测原理，具有检测周期短，无需试剂，无需水样输送和前处理，功耗低，体积小，自清洁等特点。但是和国标法相比，这些探头也有缺点，即，要达到或者接近国标法的检测准确度，需要根据当地的水质进行一定的校准。原厂状态的探头，可以准确检测数值变化，但是准确度略低，需要进行本地校准，校准过程并不复杂，获取一定量的与国标法的对比数据，即可完成校准。
      </p>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: "standardLimits",
  data() {
    return {

    };
  },
  computed: {
    ...mapState(['hideBackBtn'])
  },
  methods: {
    goback() {
      window.history.back();
    },

  }
};
</script>

<style scoped>
  .container {
    padding: 10px;
  }
  .contennt {
    font-size: 14px;
    text-indent:2em
  }
</style>


// WEBPACK FOOTER //
// src/pages/application/about.vue